import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import {
  InvestmentsTabJustWin,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Investments/InvestmentsTabJustWin/InvestmentsTabJustWin';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const InvestmentsViewPicker = ({ classes, className }) => {
  const { householdResource } = useSimpleHousehold();

  const InvestmentsView = pick(householdResource, {
    [fr.relationships.justWinPM1.name]: InvestmentsTabJustWin,
    [fr.relationships.justWinPM2.name]: InvestmentsTabJustWin,
  }, null);

  return (
    <Box className={classNames(classes.root, className)}>
      <InvestmentsView />
    </Box>
  );
};

InvestmentsViewPicker.defaultProps = {
  className: '',
};

InvestmentsViewPicker.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export { InvestmentsViewPicker };
